(function () {
  function loadSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-el-swiper="true"]');
    if (existing) {
      if (typeof Swiper !== "undefined" || existing.dataset.loaded === "true") {
        callback();
        return;
      }
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    if (!document.querySelector('link[data-el-swiper-css="true"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      link.dataset.elSwiperCss = "true";
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.dataset.elSwiper = "true";
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        callback();
      },
      { once: true }
    );
    document.body.appendChild(script);
  }

  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function destroyGallery(section) {
    if (section._elFpThumbsResizeObserver) {
      section._elFpThumbsResizeObserver.disconnect();
      delete section._elFpThumbsResizeObserver;
    }
    if (section._elFpMainSwiper) {
      section._elFpMainSwiper.destroy(true, true);
      delete section._elFpMainSwiper;
    }
    if (section._elFpThumbsSwiper) {
      section._elFpThumbsSwiper.destroy(true, true);
      delete section._elFpThumbsSwiper;
    }
  }

  function syncThumbsToMain(section) {
    const galleryEl = section.querySelector("[data-el-fp-gallery]");
    const thumbsEl = section.querySelector("[data-el-fp-thumbs]");
    if (!galleryEl || !thumbsEl) return;

    if (isMobile()) {
      if (thumbsEl.style.height || thumbsEl.style.width) {
        thumbsEl.style.height = "";
        thumbsEl.style.width = "";
        section._elFpThumbsSizeKey = "";
        section._elFpThumbsSwiper?.update();
      }
      return;
    }

    // Derive sizes from gallery width only — avoids ResizeObserver feedback loops
    // galleryWidth = thumbSize + 12 + mainSize
    // mainSize = 5 * thumbSize + 4 * 10
    // => galleryWidth = thumbSize + 12 + 5*thumbSize + 40 = 6*thumbSize + 52
    const galleryWidth = Math.floor(galleryEl.getBoundingClientRect().width);
    if (galleryWidth < 1) return;

    const thumbGap = 10;
    const galleryGap = 12;
    const visible = 5;
    const thumbSize = Math.max(
      1,
      Math.floor((galleryWidth - galleryGap - thumbGap * (visible - 1)) / (visible + 1))
    );
    const mainSize = thumbSize * visible + thumbGap * (visible - 1);
    const sizeKey = `${mainSize}x${thumbSize}`;

    if (section._elFpThumbsSizeKey === sizeKey) return;
    section._elFpThumbsSizeKey = sizeKey;

    thumbsEl.style.height = `${mainSize}px`;
    thumbsEl.style.width = `${thumbSize}px`;

    if (section._elFpThumbsSwiper) {
      section._elFpThumbsSwiper.update();
    }
  }

  function initGallery(section) {
    const galleryEl = section.querySelector("[data-el-fp-gallery]");
    const thumbsEl = section.querySelector("[data-el-fp-thumbs]");
    const mainEl = section.querySelector("[data-el-fp-main]");
    const prevEl = section.querySelector("[data-el-fp-prev]");
    const nextEl = section.querySelector("[data-el-fp-next]");

    if (!thumbsEl || !mainEl || typeof Swiper === "undefined") return;

    const slideCount = mainEl.querySelectorAll(".swiper-slide").length;
    if (slideCount < 1) return;

    const mode = isMobile() ? "mobile" : "desktop";
    if (section._elFpGalleryMode === mode && section._elFpMainSwiper) {
      syncThumbsToMain(section);
      return;
    }

    destroyGallery(section);
    section._elFpGalleryMode = mode;
    section._elFpThumbsSizeKey = "";

    const isMobileMode = mode === "mobile";
    const edgeOffset = isMobileMode ? 15 : 0;

    const thumbsSwiper = new Swiper(thumbsEl, {
      direction: isMobileMode ? "horizontal" : "vertical",
      spaceBetween: isMobileMode ? 8 : 10,
      slidesPerView: isMobileMode ? "auto" : 5,
      slidesOffsetBefore: edgeOffset,
      slidesOffsetAfter: edgeOffset,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      freeMode: isMobileMode,
    });

    const mainSwiper = new Swiper(mainEl, {
      spaceBetween: isMobileMode ? 8 : 0,
      slidesPerView: isMobileMode ? 1.2 : 1,
      slidesOffsetBefore: edgeOffset,
      slidesOffsetAfter: edgeOffset,
      loop: !isMobileMode && slideCount > 1,
      speed: 450,
      navigation:
        !isMobileMode && prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });

    section._elFpThumbsSwiper = thumbsSwiper;
    section._elFpMainSwiper = mainSwiper;

    syncThumbsToMain(section);

    if (galleryEl && typeof ResizeObserver !== "undefined") {
      let resizeFrame = 0;
      section._elFpThumbsResizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => syncThumbsToMain(section));
      });
      section._elFpThumbsResizeObserver.observe(galleryEl);
    }
  }

  function placeAccordion(section) {
    const accordion = section.querySelector("[data-el-fp-accordion]");
    const desktopSlot = section.querySelector("[data-el-fp-accordion-desktop-slot]");
    const mobileSlot = section.querySelector("[data-el-fp-accordion-mobile-slot]");
    if (!accordion || !desktopSlot || !mobileSlot) return;

    const target = isMobile() ? mobileSlot : desktopSlot;
    if (accordion.parentElement !== target) {
      target.appendChild(accordion);
    }
  }

  function initAccordion(section) {
    placeAccordion(section);

    const groups = section.querySelectorAll("[data-el-fp-accordion]");
    if (!groups.length) return;

    function closeItem(item) {
      const trigger = item.querySelector(".el-faq-section__trigger");
      const content = item.querySelector(".el-faq-section__answer");
      if (!content) return;

      content.style.height = `${content.scrollHeight}px`;
      void content.offsetHeight;
      item.classList.remove("is-open");
      content.style.height = "0px";
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    }

    function openItem(item) {
      const trigger = item.querySelector(".el-faq-section__trigger");
      const content = item.querySelector(".el-faq-section__answer");
      if (!content) return;

      item.classList.add("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");

      content.style.height = "auto";
      const fullHeight = content.scrollHeight;
      content.style.height = "0px";
      void content.offsetHeight;
      content.style.height = `${fullHeight}px`;

      const onEnd = (event) => {
        if (event.propertyName !== "height") return;
        content.removeEventListener("transitionend", onEnd);
        if (item.classList.contains("is-open")) {
          content.style.height = "auto";
        }
      };
      content.addEventListener("transitionend", onEnd);
    }

    groups.forEach((group) => {
      group.querySelectorAll("[data-el-faq-item]").forEach((item) => {
        const content = item.querySelector(".el-faq-section__answer");
        if (content && !item.classList.contains("is-open")) {
          content.style.height = "0px";
          content.style.overflow = "hidden";
        }
      });

      if (group.dataset.elFpAccordionReady === "true") return;
      group.dataset.elFpAccordionReady = "true";

      group.addEventListener("click", (event) => {
        const trigger = event.target.closest(".el-faq-section__trigger");
        if (!trigger || !group.contains(trigger)) return;

        const item = trigger.closest("[data-el-faq-item]");
        if (!item) return;

        event.preventDefault();
        const isOpen = item.classList.contains("is-open");

        group.querySelectorAll("[data-el-faq-item].is-open").forEach((openItem) => {
          if (openItem !== item) closeItem(openItem);
        });

        if (isOpen) {
          closeItem(item);
          return;
        }

        openItem(item);
      });
    });
  }

  function syncVariantId(section, variantId, available) {
    const idInput = section.querySelector("[data-el-fp-variant-id-input]");
    const atcButton = section.querySelector("[data-el-fp-atc]");

    if (idInput) {
      idInput.value = String(variantId);
      idInput.disabled = !available;
    }

    if (atcButton) {
      atcButton.disabled = !available;
    }
  }

  function initVariants(section) {
    const variantsRoot = section.querySelector("[data-el-fp-variants]");
    if (!variantsRoot) return;

    const radios = variantsRoot.querySelectorAll("[data-el-fp-variant-id]");

    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (!radio.checked) return;

        variantsRoot.querySelectorAll(".el-feature-product__variant").forEach((card) => {
          card.classList.toggle("is-selected", card.contains(radio));
        });

        const available = radio.dataset.elFpVariantAvailable === "true";
        syncVariantId(section, radio.value, available);

        section.dispatchEvent(
          new CustomEvent("el-fp:variant-change", {
            bubbles: true,
            detail: {
              variantId: Number(radio.value),
              available,
            },
          })
        );
      });
    });

    const checked = variantsRoot.querySelector("[data-el-fp-variant-id]:checked");
    if (checked) {
      syncVariantId(section, checked.value, checked.dataset.elFpVariantAvailable === "true");
    }
  }

  function initBuyButton(section) {
    const buyRoot = section.querySelector("[data-el-fp-buy]");
    const form = buyRoot?.querySelector('form[data-type="add-to-cart-form"]');
    const submitButton = buyRoot?.querySelector("[data-el-fp-atc]");
    const errorEl = buyRoot?.querySelector("[data-el-fp-buy-error]");

    if (!buyRoot || !form || !submitButton || buyRoot.dataset.elFpBuyBound === "true") return;
    buyRoot.dataset.elFpBuyBound = "true";

    const directToCheckout = buyRoot.dataset.elFpDirectCheckout === "true";

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (submitButton.disabled || submitButton.getAttribute("aria-disabled") === "true") return;

      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      const formData = new FormData(form);
      const mainVariantId = formData.get("id");
      const mainQuantity = Number(formData.get("quantity") || 1);

      const freeVariantIds = Array.from(
        section.querySelectorAll("[data-el-fp-free-variant-id]")
      )
        .map((el) => el.getAttribute("data-el-fp-free-variant-id"))
        .filter(Boolean);

      const items = [
        {
          id: Number(mainVariantId),
          quantity: mainQuantity,
        },
        ...freeVariantIds.map((variantId) => ({
          id: Number(variantId),
          quantity: 1,
        })),
      ];

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }

      submitButton.setAttribute("aria-disabled", "true");
      submitButton.classList.add("is-loading");

      let redirectingToCheckout = false;

      try {
        if (directToCheckout) {
          const clearResponse = await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });

          if (!clearResponse.ok) {
            throw new Error("Unable to clear cart.");
          }

          const addResponse = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items }),
          });
          const addData = await addResponse.json();

          if (addData.status) {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = addData.description || addData.message || "Unable to add to cart.";
            }
            return;
          }

          redirectingToCheckout = true;
          window.location.href = "/checkout";
          return;
        }

        if (freeVariantIds.length) {
          formData.delete("id");
          formData.delete("quantity");
          formData.append("items[0][id]", String(mainVariantId));
          formData.append("items[0][quantity]", String(mainQuantity));

          freeVariantIds.forEach((variantId, index) => {
            const itemIndex = index + 1;
            formData.append(`items[${itemIndex}][id]`, String(variantId));
            formData.append(`items[${itemIndex}][quantity]`, "1");
          });
        }

        if (cart?.getSectionsToRender) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((sectionItem) => sectionItem.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement?.(document.activeElement);
        }

        const config =
          typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : {
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/javascript",
                },
              };

        delete config.headers["Content-Type"];
        config.body = formData;

        const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", config);
        const data = await response.json();

        if (data.status) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = data.description || data.message || "Unable to add to cart.";
          }
          return;
        }

        if (!cart) {
          window.location = window.routes?.cart_url || "/cart";
          return;
        }

        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "el-feature-product",
            productVariantId: mainVariantId,
            cartData: data,
          });
        }

        cart.classList?.remove("is-empty");
        cart.renderContents?.(data);
      } catch (error) {
        console.error(error);
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = "Unable to add to cart.";
        }
      } finally {
        if (!redirectingToCheckout) {
          submitButton.classList.remove("is-loading");
          submitButton.removeAttribute("aria-disabled");
        }
      }
    });
  }

  function initFeatureProduct(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-feature-product]").forEach((section) => {
      initAccordion(section);
      initVariants(section);
      initBuyButton(section);
    });
  }

  function initFeatureProductGallery(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-feature-product]").forEach((section) => {
      initGallery(section);
    });
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll("[data-el-feature-product]").forEach((section) => {
        placeAccordion(section);
        initGallery(section);
        syncThumbsToMain(section);
      });
    }, 150);
  }

  function boot(root) {
    initFeatureProduct(root);
    loadSwiper(() => initFeatureProductGallery(root));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }

  window.addEventListener("resize", onResize);

  document.addEventListener("shopify:section:load", (event) => {
    boot(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector?.("[data-el-feature-product]") || event.target;
    if (section?.matches?.("[data-el-feature-product]")) {
      destroyGallery(section);
    }
  });
})();
